import script from "./navigationSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./navigationSidebar.vue?vue&type=script&setup=true&lang=js"

import "./navigationSidebar.vue?vue&type=style&index=0&id=782d1f9a&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-782d1f9a"]])

export default __exports__